<template>
  <div>
    <nuxt-layout name="default">
      <section class="mt-4 lg:mt-8 lg:mb-6 mb-24 overflow-hidden">
        <div class="container px-4 xl:px-0">
          <p-breadcrumbs :breadcrumbs="breadcrumbs"></p-breadcrumbs>
        </div>

        <div
          class="mt-4 container px-4 xl:px-0 flex items-center justify-between"
        >
          <div
            class="pb-5 text-xl md:text-6xl font-lato text-gray-900 font-semibold"
          >
            {{ product.name }}
          </div>
          <p class="text-gray-400 font-lato lg:block hidden">
            Арт.{{ product.code }}
          </p>
        </div>
        <p-card-detailed
          :product="product"
          :productsByCategory="productsByCategory"
          @showMore="showMore()"
        ></p-card-detailed>
        <p-product-info class="block mt-3 lg:hidden"></p-product-info>
        <p-product-description
          :product="product"
          class="mt-5"
        ></p-product-description>
        <p-product-characteristic
          :attributes="product.attributes"
          class="mt-5"
        ></p-product-characteristic>
        <ClientOnly>
          <p-viewed-products class="mt-5 md:pb-17" />
        </ClientOnly>
      </section>
    </nuxt-layout>
  </div>
</template>

<script setup>
import POSITIVE_LOGO from "@/assets/img/positive-logo.png";
import { useRecentlyViewedStore } from "~/stores";
import { findBreadcrumbsById } from "~/utils/breadcrumbs";
const recentlyViewedStore = useRecentlyViewedStore();
const activeLink = ref("description");

const handleLinkClick = (link) => {
  activeLink.value = link;
};
const route = useRoute();

recentlyViewedStore.addViewedProduct(route.params?.id);

const { $get } = useAxios();

const { data: product, pending: isProductLoading } = await useAsyncData(
  `get product by id - ${route.params.id}`,
  () => $get(`/api/v1/product/${route.params.id}`),
  { default: () => {} }
);

const item = findBreadcrumbsById(product.value.category.public_id);
const breadcrumbs = {
  label: product.value.name,
  parent: [...item.parent, { label: item.label, id: item.id }],
};

const { data: productsByCategory, pending: isProductsLoading } =
  await useAsyncData(
    `get simular product by id - ${route.params.id}`,
    () => $get(`/api/v1/product/get/analogues/${route.params.id}?limit=2`),
    { default: () => [] }
  );

function showMore() {
  window.scrollTo(0, 850);
}

const head = computed(() => {
  return {
    title: `ООО "Позитив"`,
    meta: [
      {
        hid: "title",
        property: "title",
        content: `${product.value?.name}`,
      },
      {
        hid: "og:title",
        property: "og:title",
        content: `${product.value?.name}`,
      },
      {
        hid: "description",
        name: "description",
        content: `${product.value?.name} - выгодная цена, характеристика, фото - купить на сайте positive.ooo`,
      },
      {
        hid: "og:description",
        property: "og:description",
        content: `${product.value?.name} - выгодная цена, характеристика, фото - купить на сайте positive.ooo`,
      },
      {
        hid: "url",
        name: "url",
        content: `https://positive.ooo/product/${product.value.public_id}`,
      },
      {
        hid: "og:url",
        property: "og:url",
        content: `https://positive.ooo/product/${product.value.public_id}`,
      },
      {
        hid: "image",
        name: "image",
        content: `${product.value?.imageUrl ?? POSITIVE_LOGO}`,
      },
      {
        name: "og:image",
        property: "og:image",
        content: `${product.value?.imageUrl ?? POSITIVE_LOGO}`,
      },
    ],
  };
});

useHead(head);
</script>

<style scoped>
.active-link {
  position: relative;
  transition: font-size 0.2s;
}

.active-link::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -24px;
  width: 100%;
  border-bottom: 3px solid black;
}
</style>
